import { usePage } from '@inertiajs/react';
import { Box, Container, Typography } from '@mui/material';
import AdminProfileCard from '../../components/admin/AdminProfileCard';

interface TourRequest {
    id: string;
    status: string;
    listing_address: string;
    listing_url: string;
    rent: number;
    neighborhood: string | null;
    bedrooms: number | null;
    bathrooms: number | null;
    landlord_intro_message: string | null;
    match_rating: number | null;
    rejection_reason: string | null;
    tour_giver_name: string | null;
    listing_contact_email: string;
    created_at: string;
    tour_slot: {
        id: string;
        date: string;
        start_time_local: string;
        end_time_local: string;
    };
}

interface ProspectData {
    id: string;
    name: string;
    email: string;
    phone_number: string | null;
    created_at: string;
    updated_at: string;
    search_status: string;
    credit_score: number | null;
    age_range: string | null;
    new_renter: boolean | null;
    has_year_long_rental: boolean | null;
    current_living_situation: string | null;
    living_situation_explained: string | null;
    student: boolean | null;
    undergraduate: boolean | null;
    currently_employed: boolean | null;
    rent_payment_without_job: string | null;
    explain_rent_payment: string | null;
    income_verifiable: boolean | null;
    has_current_job_for_year: boolean | null;
    has_one_year_employment_history_last_3_years: boolean | null;
    will_do_background_and_credit_check: boolean | null;
    num_cats: number | null;
    num_dogs: number | null;
    lease_length_requested: string | null;
    move_in_date_requested: string | null;
    moving_reason: string | null;
    number_of_applicants: string | null;
    tour_preference: string | null;
    additional_search_info: string | null;
    budget: number | null;
    employer: string | null;
    occupation: string | null;
    neighborhoods: string | null;
    num_bedrooms_wanted: number | null;
    num_bathrooms_wanted: number | null;
    housing_voucher: boolean | null;
    short_intro: string | null;
    profile_pic_url: string | null;
    rental_type: number | null;
    short_code: string | null;
}

interface Props {
    prospect: ProspectData;
    tour_requests: TourRequest[];
    upcoming_tours: (TourRequest & { is_past?: boolean })[];
    [key: string]: any;
}

export default function AdminRenterProfilePage() {
    const { props } = usePage<Props>();
    const { prospect, tour_requests, upcoming_tours } = props;

    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            {/* Page Title */}
            <Box sx={{ mb: 4 }}>
                <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
                    Prospect Details
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    Viewing profile for {prospect.name}
                </Typography>
            </Box>

            {/* Profile Card */}
            <AdminProfileCard
                prospect={prospect}
                tour_requests={tour_requests}
                upcoming_tours={upcoming_tours}
            />
        </Container>
    );
}

